import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthenticationContextType } from 'Foundation/Authentication';
import {
  overrideMasterPoolRemarks,
  type AddModifyRemarsksPayload
} from '../HbtMasterPoolNumberAddRemarksService';

export const useMasterPoolAddRemarksMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      authenticationContext,
      masterPoolNumber,
      payload
    }: {
      authenticationContext: AuthenticationContextType;
      masterPoolNumber: number;
      payload: AddModifyRemarsksPayload;
    }) => {
      const response = await overrideMasterPoolRemarks({
        authenticationContext,
        masterPoolNumber,
        payload
      });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['master-pool-inventory-table'] });
      queryClient.invalidateQueries({ queryKey: ['masterpool-number-historical-remarks'] });
    },
    onError: (error) => {
      throw new Error(error.message ?? 'Error while updating remarks');
    }
  });
};
